import { startOfDay } from 'date-fns'
import { createEvent, createStore } from 'effector'
import { ONE_HOUR_MS, ONE_MINUTE_MS } from '~/shared/constants/time'
import { setIntervalTick } from '../effector'
import { TICK_FREQUENCY } from './index.h'

// setup global application clock
export const setup = createEvent()

const $updateInterval = createStore(TICK_FREQUENCY)

const { teardown, tick } = setIntervalTick({
  init: setup,
  $intervalMs: $updateInterval,
})

//
// Stores with time
//

// current timestamp, which is updated on every minute (if clock is ticking)
export const $minutes = createStore(0)
  .reset(teardown)
  .on(tick, (_, now) => Math.trunc(now / ONE_MINUTE_MS) * ONE_MINUTE_MS)

// current timestamp, which is updated on every hour (if clock is ticking)
export const $hours = createStore(0)
  .reset(teardown)
  .on(tick, (_, now) => Math.trunc(now / ONE_HOUR_MS) * ONE_HOUR_MS)

// timestamp of day beginning, which is updated on every day (if clock is ticking)
export const $days = createStore(0)
  .reset(teardown)
  .on(tick, (_, now) => startOfDay(now).getTime())
